import { ref } from 'vue'
import * as THREE from 'three'
import { setMeshAppearance } from '@/utils/meshAppearance'

export function useViewerHighlights() {
  const pointerOnPart = ref(false)

  let hoveredMeshes: THREE.Mesh[] = []
  let lastHoverMesh: THREE.Mesh | null = null
  let selectedMeshes: THREE.Mesh[] = []

  function hoverChanged(mesh: THREE.Mesh | null): boolean {
    if (mesh === lastHoverMesh) return false
    lastHoverMesh = mesh
    return true
  }

  function clearHover() {
    for (const m of hoveredMeshes) setMeshAppearance(m, { hovered: false })
    hoveredMeshes = []
    lastHoverMesh = null
    pointerOnPart.value = false
  }

  function applyHover(meshes: THREE.Mesh[]) {
    clearHover()
    hoveredMeshes = meshes.filter((m) => !selectedMeshes.includes(m))
    for (const m of hoveredMeshes) setMeshAppearance(m, { hovered: true })
    pointerOnPart.value = true
  }

  function applySelectionHighlight(meshes: THREE.Mesh[]) {
    clearSelectionHighlight()
    selectedMeshes = meshes
    for (const m of meshes) setMeshAppearance(m, { selected: true })
  }

  function clearSelectionHighlight() {
    for (const m of selectedMeshes) setMeshAppearance(m, { selected: false })
    selectedMeshes = []
  }

  return {
    pointerOnPart,
    hoverChanged,
    applyHover,
    clearHover,
    applySelectionHighlight,
    clearSelectionHighlight,
  }
}
